import { Rotate3dVariantIcon } from './Rotate3dVariantIcon';

/**
 * author: Austin Andrews
 * id D09D0551-14A0-470B-A24C-0AC38F739FFA
 * name rotate-3d-variant
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/rotate-3d-variant.svg
 * tags
 */
export const _3dRotationIcon = Rotate3dVariantIcon;
export default _3dRotationIcon